import { UserIdentityFlowAction } from "@/services/UserIdentitiesService";
import type { UserIdentityStatusDto } from "@/services/UserIdentitiesService";

//  diaphanumClient → existe en Omnia/NextPortfolio pero no en IronIA: el alta la hacemos nosotros
//  otherUser       → interviniente de otro usuario: se pide acceso al titular (préstamo con su aprobación)
//  alreadyExists   → cualquier otro caso (ya es interviniente propio, cesiones...): no se vuelve a dar de alta
export type ExistingRepresentativeKind = "diaphanumClient" | "otherUser" | "alreadyExists";

export function getExistingRepresentativeKind(status: UserIdentityStatusDto | null): ExistingRepresentativeKind
{
    switch(status?.action)
    {
        case UserIdentityFlowAction.InformationManualSignUpRequired:
            return "diaphanumClient";
        case UserIdentityFlowAction.RequestAccess:
            return "otherUser";
        default:
            return "alreadyExists";
    }
}

/** Id del interviniente al que se pide acceso (el backend lo devuelve en existingDraftId con RequestAccess). */
export function getAccessRequestTargetId(status: UserIdentityStatusDto | null): number | null
{
    if(status?.action !== UserIdentityFlowAction.RequestAccess)
    {
        return null;
    }

    const id = Number(status.existingDraftId ?? 0);
    return id > 0 ? id : null;
}
